import { NavLink, useLocation } from "react-router-dom";
import { Briefcase, FileText, ClipboardCheck, Settings2, Search, Library, Users } from "lucide-react";

const TABS = [
  { to: "/app/recruit/jobs", label: "Jobs", icon: Briefcase, testId: "recruit-tab-jobs" },
  { to: "/app/recruit/descriptions", label: "Descriptions", icon: FileText, testId: "recruit-tab-descriptions" },
  { to: "/app/recruit/talent", label: "Talent", icon: Search, testId: "recruit-tab-talent" },
  { to: "/app/recruit/pools", label: "Pools", icon: Users, testId: "recruit-tab-pools" },
  { to: "/app/recruit/library", label: "Library", icon: Library, testId: "recruit-tab-library" },
  { to: "/app/recruit/assessments", label: "Assessments", icon: ClipboardCheck, testId: "recruit-tab-assessments" },
  { to: "/app/recruit/settings", label: "Job settings", icon: Settings2, testId: "recruit-tab-settings" },
];

export default function RecruitSubNav() {
  const { pathname } = useLocation();
  // Hide on Job detail / Candidate detail pages (they have their own back nav)
  if (/\/app\/recruit\/(jobs|candidates)\/[^/]+/.test(pathname)) return null;
  return (
    <div className="mb-6 border-b" data-testid="recruit-subnav">
      <div className="flex flex-wrap gap-1">
        {TABS.map(t => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === "/app/recruit/jobs"}
            data-testid={t.testId}
            className={({ isActive }) =>
              `inline-flex items-center gap-2 px-4 py-2.5 text-sm rounded-t-lg -mb-px border-b-2 transition-colors ${
                isActive
                  ? "border-pink text-pink font-semibold"
                  : "border-transparent text-neutral-500 hover:text-neutral-900"
              }`
            }
          >
            <t.icon className="w-4 h-4" />
            {t.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
